export function redirectToLogin() {
    if (window.location.href.indexOf("stage") !== -1)
        window.location.href = "https://stage.creaza.com/sign-in";
    else
        window.location.href = "https://www.creaza.com/sign-in";
}